import React, { useRef, useState } from 'react';
import { type ImageType } from '@/common/types/image.type';
import type SwiperCore from 'swiper';
import { type SwiperRef } from 'swiper/react';
import GalleryCarousel from '@/common/components/gallery-carousel/gallery-carousel.component';
import CarouselSlides from '@/common/components/image-carousel-slides/carousel-slides.component';

interface UploadFiles {
  images: ImageType[];
  selectedImage?: number;
  setSelectedImage?: (index: number) => void;
}
function ImageGallery({
  images,
  selectedImage,
  setSelectedImage,
}: UploadFiles) {
  const [activeIndex, setActiveIndex] = useState<number>(selectedImage || 0);
  const carouselRef = useRef<SwiperRef>(null);

  const handleIndex = (index: number) => {
    setActiveIndex(index);
    carouselRef.current?.swiper.slideTo(index);
  };

  const handleSlideChange = (swiper: SwiperCore) => {
    const newIndex = swiper.realIndex;
    setActiveIndex(newIndex);
    carouselRef.current?.swiper.slideTo(newIndex);
    if (setSelectedImage) setSelectedImage(newIndex);
  };

  return (
    <div className="h-full">
      <GalleryCarousel
        initialSlide={activeIndex}
        activeIndex={activeIndex}
        images={images}
        onSlideChange={handleSlideChange}
      />

      <CarouselSlides
        initialSlide={activeIndex}
        carouselRef={carouselRef}
        images={images}
        activeIndex={activeIndex}
        onIndexChange={handleIndex}
        className="carousel mt-5 cursor-pointer"
      />
    </div>
  );
}

export default ImageGallery;
